import React, { useEffect, useRef } from 'react';
import './style.scss'

import { useField } from '@unform/core';

function Input({ name, titulo, icon, col, hidden, action, ...props }) {
    const inputRef = useRef(null);
    const { fieldName, defaultValue, registerField, error } = useField(name);

    useEffect(() => {
        registerField({
            name: fieldName,
            ref: inputRef.current,
            path: 'value',
        });
    }, [fieldName, registerField]);

    return (
        <div className={`cInputD group-input-${name} ${col}`} style={{ display: `${hidden ? 'none' : ''}` }}>
            <label htmlFor={name}>{titulo}</label>
            <div style={{ position: 'relative' }}>
                <input id={name} autoComplete='off' ref={inputRef} defaultValue={defaultValue} {...props} style={{ width: '100%' }} />
                {
                    action &&
                    <div className='input-action-btn' onClick={action.onClick} title={action.title}>
                        <i className={action.icon}></i>
                    </div>
                }
            </div>
            {error && <span className="error-validacao">{error}</span>}
        </div>
    );
}

export default Input